import { defineMessages } from "@/lib/i18n/messages";

export default defineMessages({
  es: {
    title: "¿De qué país quieres recibir eventos?",
    description: "Elige una o varias carteleras: te llega un correo por cada país, cada lunes y cada viernes.",
    search: "Buscar país...",
    empty: "No encontramos ese país.",
    remove: (country: string) => `Quitar ${country}`,
    cancel: "Cancelar",
    confirm: (n: number) => (n > 1 ? `Suscribirme a ${n} carteleras` : "Suscribirme"),
  },
  en: {
    title: "Which country do you want events from?",
    description: "Pick one or several listings: you'll get one email per country, every Monday and every Friday.",
    search: "Search country...",
    empty: "We couldn't find that country.",
    remove: (country: string) => `Remove ${country}`,
    cancel: "Cancel",
    confirm: (n: number) => (n > 1 ? `Subscribe to ${n} listings` : "Subscribe"),
  },
});
